<template>
  <v-dialog
    :value="true"
    max-width="480"
    persistent
    @click:outside="$emit('click:outside')"
  >
    <v-card>
      <v-card-title class="headline">{{ title }}</v-card-title>
      <v-card-text>
        {{ description }}
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn large outlined text @click="$emit('cancel')">
          {{ textBtnCancel }}
        </v-btn>
        <v-btn color="primary" large outlined text @click="$emit('confirm')">
          {{ textBtnConfirm }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'SimpleConfirmDialog',
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    textBtnCancel: {
      type: String,
      default: 'Cancelar',
    },
    textBtnConfirm: {
      type: String,
      default: 'Confirmar',
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/theme.scss';
@import '@/assets/scss/theme-v2.scss';

.wrapper-mirror {
  width: 600px;

  .section-title {
    margin-bottom: 16px;
    margin-left: 4px;
    color: $color-gray-dark;
    font-size: 1.1em;
  }

  .mirror-folder-input {
    display: flex;
    height: 36px;
    margin-bottom: 16px;

    .mirror-folder-input-place {
      height: 36px;
      flex: 0 0 88px !important;
      margin: 0 4px 0 0;
    }

    .v-text-field {
      margin: 0 4px 0 4px;
    }

    .create-button {
      flex: 0 0 64px !important;
    }

    .save-mirror-button {
      margin-left: auto;
      margin-right: 4px;
    }

    .clear-button {
      margin-right: 4px;
    }

    .hidden {
      display: none;
    }

    .actions {
      margin-bottom: 16px;
    }
  }
}

.v-dialog {
  .v-card {
    padding: 24px;
    overflow: hidden;

    @include for-size(phone-only) {
      padding: 16px 8px;
    }

    // Icon
    .row {
      justify-content: center;

      i {
        font-size: 4em;
        opacity: 0.24;
      }
    }

    // Title
    .v-card__title {
      position: relative;
      text-align: center;
      justify-content: center;
      font-style: italic;
      color: $color-gray-dark;
      margin: -8px 0 24px 0;

      @include for-size(phone-only) {
        margin: -8px 0 8px 0;
      }
    }

    // Text
    .v-card__text {
      font-size: 1em;
      color: $color-gray-main;
      text-align: center;

      @include for-size(phone-only) {
        font-size: 0.88em;
        line-height: 1.2em;
      }

      span {
        font-family: 'globotipo' !important;
        font-weight: 700 !important;
        color: $color-gray-dark;
      }
    }

    ::v-deep .v-card__actions {
      justify-content: flex-end;

      @include for-size(phone-only) {
        display: flex;
        flex-wrap: wrap;

        .v-btn {
          flex: 0 0 100%;
          margin: 0 0 8px 0;
        }
      }
    }
  }
}
</style>
